import { loopControlProps, makeControlProps, backgroundProps, visibilityProps } from './helper';

const properties = [
  makeControlProps('input', {
    pathValue: 'properties.backendname',
    label: 'Backendname'
  }),
  makeControlProps('input', {
    pathValue: 'properties.source',
    label: 'Source for Video'
  }),
  visibilityProps,
  loopControlProps
]

const view = [
  {
    selector: '.mbst-video-player',
    controls: [
      makeControlProps('sizing', {
        label: 'Sizing',
        width: {
          label: 'Width',
          measure: ['px', 'em', '%', 'rem',  'vw', 'wh'],
          pathValue: 'width'
        },
        height: {
          label: 'Height',
          measure: ['px', 'em', '%', 'rem', 'vw', 'vh'],
          pathValue: 'height'
        }
      }),
      makeControlProps('spacing', { label: 'Spacing' }),
      makeControlProps('borders', { label: 'Borders' }),
      makeControlProps('corners', { label: 'Corners', pathValue: 'border-radius' }),
      backgroundProps,
    ]
  }
]

const actions = []

export default {
  properties,
  view,
  actions
}
